'use client'

import { WarningGlyphOutlineIcon } from '@/components/icons/WarningGlyphOutlineIcon'
import { GlobalPageLayout } from '@/components/layout/global/GlobalPageLayout'

export type ErrorPageProps = {
  error: Error
}

export default function ErrorPage({ error }: ErrorPageProps) {
  return (
    <GlobalPageLayout>
      <main className="grid p-3">
        <div className="grid place-content-center justify-items-center gap-4 rounded-lg border border-[#B3B3B3] bg-white p-3 dark:border-[#4A4A4A] dark:bg-[#2B2B2B]">
          <WarningGlyphOutlineIcon className="w-12 text-[#DC5018] dark:text-[#F5A622]" />
          <h1 className="text-center text-4xl font-medium text-[#DC5018] dark:text-[#F5A622]">
            Error
          </h1>
          <p className="text-center text-2xl text-[#DC5018] dark:text-[#F5A622]">{error.message}</p>
        </div>
      </main>
    </GlobalPageLayout>
  )
}
